import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="list-filter-titles"
export default class extends Controller {
  static values = { url: String, frameId: String }

  reload (event) {
    if (event.target !== this.element) return

    const frame = document.getElementById(this.frameIdValue)
    if (!frame) return

    const query = new URLSearchParams(new FormData(this.element)).toString()
    frame.src = `${this.urlValue}?${query}`
  }
}
